module.exports = "/assets/pattern-footer.png?ALZQ6OI";